export default __webpack_public_path__ + "static/media/video-sound-on.d0091299.svg";